// Deprecated: testimonials control cloning removed.
// Sleek's built-in testimonials controls are the single source of truth.
if (window?.Shopify?.designMode) {
  console.debug('[custom-testimonials] disabled: using native section controls only');
}
// no-op
